export const SIZES = {
    XXS: 12,
    XS: 16,
    S: 20,
    M: 24,
    SL: 28,
    L: 32,
    XL: 44,
    XXL: 56,
    XXXL: 64,
};
